import PropTypes from 'prop-types';
import * as React from 'react';
import SwipeableViews from 'react-swipeable-views';
// import { useTheme } from '@mui/material/styles';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import Typography from '@mui/material/Typography';
import { IconCheck } from '@tabler/icons';
import utils from '../assets/utils/utils';

function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    'aria-controls': `full-width-tabpanel-${index}`,
  };
}

export default function FullWidthTabs({ products, lgUp, theme }) {
  const [value, setValue] = React.useState(0);
  // const {description, rules, steps, eligibility,features} = products;

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleChangeIndex = (index) => {
    setValue(index);
  };

  return (
    <Box
      sx={{
        bgcolor: 'Background.paper',
        width: '100%',
        top: 0,
        maxWidth: lgUp ? '' : '90vw',
        minWidth: '72vw',
        ml: lgUp ? '0' : '-25px',
        pr: 1,
      }}
    >
      <AppBar position="sticky">
        <Tabs
          value={value}
          onChange={handleChange}
          indicatorColor="action.active"
          textColor="inherit"
          variant="scrollable"
          scrollButtons
          allowScrollButtonsMobile
          aria-label="scrollable auto tabs"
          sx={{ bgcolor: theme.palette.earnpati.nav, color: 'white' }}
        >
          <Tab label="Details" sx={{ fontWeight: 700 }} {...a11yProps(0)} />
          <Tab label="About" sx={{ fontWeight: 700 }} {...a11yProps(1)} />
          <Tab label="Features" sx={{ fontWeight: 700 }} {...a11yProps(2)} />
          <Tab label="Eligibilty" sx={{ fontWeight: 700 }} {...a11yProps(3)} />
          <Tab label="TnC" sx={{ fontWeight: 700 }} {...a11yProps(4)} />
          <Tab label="Steps" sx={{ fontWeight: 700 }} {...a11yProps(5)} />
        </Tabs>
      </AppBar>
      <SwipeableViews
        axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
        index={value}
        onChangeIndex={handleChangeIndex}
      >
        <TabPanel value={value} index={0} dir={theme.direction}>
          {utils.createElementsFromString(utils.formatString(products.payout_details))}
        </TabPanel>
        <TabPanel value={value} index={1} dir={theme.direction}>
          {utils.createElementsFromString(utils.formatString(products.description))}
        </TabPanel>
        <TabPanel value={value} index={2} dir={theme.direction}>
          {'features' in products
            ? products.features.map((lines) => {
                return (
                  <>
                    <Typography style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                      <IconCheck
                        width={24}
                        height={30}
                        style={{ marginTop: '4px', minWidth: '24px' }}
                      />
                      {utils.formatString(lines)}
                    </Typography>
                    <br />
                  </>
                );
              })
            : null}
        </TabPanel>

        <TabPanel value={value} index={3} dir={theme.direction}>
          {'eligibilty' in products
            ? products.eligibilty.map((lines) => {
                return (
                  <>
                    <Typography style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                      <IconCheck
                        width={24}
                        height={30}
                        style={{ marginTop: '4px', minWidth: '24px' }}
                      />
                      {utils.formatString(lines)}
                    </Typography>
                    <br />
                  </>
                );
              })
            : null}
        </TabPanel>
        <TabPanel value={value} index={4} dir={theme.direction}>
          {'rules' in products
            ? products.rules.map((lines) => {
                return (
                  <>
                    <Typography style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                      <IconCheck
                        width={24}
                        height={30}
                        style={{ marginTop: '4px', minWidth: '24px' }}
                      />
                      {utils.formatString(lines)}
                    </Typography>
                    <br />
                  </>
                );
              })
            : null}
        </TabPanel>
        <TabPanel value={value} index={5} dir={theme.direction}>
          {'steps' in products
            ? products.steps.map((lines) => {
                return (
                  <>
                    <Typography style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                      <IconCheck
                        width={24}
                        height={30}
                        style={{ marginTop: '4px', minWidth: '24px' }}
                      />
                      {utils.formatString(lines)}
                    </Typography>
                    <br />
                  </>
                );
              })
            : null}
        </TabPanel>
      </SwipeableViews>
    </Box>
  );
}
